import { useQuery, useMutation } from '@tanstack/react-query';
import { api } from '../services/api';

// Fetch connected social accounts for the given access key
const useGetSocialAccounts = (enabled = false, onSuccess, onError) => {
  return useQuery({
    queryKey: ['social-accounts'],
    queryFn: () => api.fetchSocialAccounts(),
    enabled,
    select: (res) => (Array.isArray(res) ? res : res?.data || []),
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Social accounts fetch error:', error);
      if (onError) onError(error);
    },
    retry: 1,
    cacheTime: 30 * 60 * 1000, // Cache for 30 minutes
  });
};

const useConnectInstagram = () => {
  return useMutation({
    mutationFn: () => api.connectInstagramAccount(),
  });
};

const useConnectFacebook = () => {
  return useMutation({
    mutationFn: () => api.connectFacebookAccount(),
  });
};

const useDisconnectSocialAccount = () => {
  return useMutation({
    mutationFn: (accountId) => api.disconnectAccount(accountId),
  });
};
const useDisconnectSocial = () => {
  return useMutation({
    mutationFn: (accountId) => api.disconnectSocial(accountId),
  });
};

export {
  useConnectInstagram,
  useConnectFacebook,
  useGetSocialAccounts,
  useDisconnectSocialAccount,
  useDisconnectSocial,
};
